import { render } from "./EtcItem.vue?vue&type=template&id=1dbe954c"
import script from "./EtcItem.vue?vue&type=script&lang=js"
export * from "./EtcItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__